// https://vuex.vuejs.org/en/mutations.html
import * as TYPES from './mutations-types';

/* eslint-disable no-param-reassign */
export default {
  [TYPES.SET_USER](state, value) {
    state.user = value
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/store/mutations.js